import { useMemo } from 'react'

import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'
import { paramsSelector, useStore } from '@liveHelper/models/store'

interface Return {
  showWidgetOnLeftSide: boolean
}

/**
 * Hook to determine the position of the widget
 */
export const useWidgetPosition = (): Return => {
  const { live_helper_placement } = useStore(paramsSelector)
  const chatChannelConfig = useChatChannelConfig()

  return useMemo(() => {
    const showWidgetOnLeftSide = live_helper_placement
      ? live_helper_placement === 'BOTTOM_LEFT'
      : chatChannelConfig?.widget_style?.widget_position === 'left'
    return {
      showWidgetOnLeftSide,
    }
  }, [live_helper_placement, chatChannelConfig])
}
